import { patientNamespace } from "@/store/modules/patient";
import { Alert } from "@/store/types";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AlertMessage from "./AlertMessage";

@Component({
  components: { AlertMessage: AlertMessage }
})
export default class AlertsIcon extends Vue {
  @Prop(Array)
  alerts!: Array<Alert>;

  @Prop(Boolean)
  showTime!: boolean;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  get filteredAlerts() {
    const postFilter = _.cloneDeep(this.alerts)
      .filter(alert => {
        return alert.level > 0;
      })
      .map(alert => {
        // Update reviewed alerts to show the correct check icon
        if (this.towerMode && alert.reviewStatus > 0) {
          alert.icon = `alertCheck${alert.reviewStatus}`;
        }
        return alert;
      });
    return postFilter;
  }
}
